import { render } from "./foodPaymentReport.vue?vue&type=template&id=94866ec2&scoped=true"
import script from "./foodPaymentReport.vue?vue&type=script&lang=js"
export * from "./foodPaymentReport.vue?vue&type=script&lang=js"

import "./foodPaymentReport.vue?vue&type=style&index=0&id=94866ec2&scoped=true&lang=scss"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94866ec2"]])

export default __exports__